/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { forwardRef } from "react";

import { spacing } from "../../../../../../global/emotion";
import type { CarouselApi } from "../../../../../hooks/useCarousel";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import type { HallowElement } from "../../../../../types/hallowElement.types";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";
import { CarouselItem } from "../CarouselItem/CarouselItem.emotion";

const hallowElement: HallowElement = "div";

const baseStyle: Interpolation<{
  pageOffsetForPosition: CarouselApi["pageOffset"][number];
}> = (props) => ({
  margin: 0,
  minHeight: spacing.t,
  width: `${props.pageOffsetForPosition[0]}px`,
  [cssMediaQueryMinWidthTablet]: {
    margin: 0,
    width: `${props.pageOffsetForPosition[1]}px`,
  },
});

export type CarouselPageOffsetProps = HallowElementProps<
  typeof hallowElement
> & {
  carouselApi: CarouselApi;
  pageOffsetPosition?: "end" | "start";
};

export const CarouselPageOffset = forwardRef<
  HTMLDivElement,
  CarouselPageOffsetProps
>(({ carouselApi, pageOffsetPosition = "start", ...props }, ref) => (
  <CarouselItem
    carouselApi={carouselApi}
    ref={ref}
    css={baseStyle({
      pageOffsetForPosition:
        carouselApi.pageOffset[pageOffsetPosition === "end" ? 1 : 0],
    })}
    {...props}
  />
));

CarouselPageOffset.displayName = "CarouselPageOffset";
